// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_1v4","cls2":"common-cls2_dV5 common-cls1_1v4"};